export default {
  back: [
    {
      command: 'backColor',
      value: '#000'
    },
    {
      command: 'backColor',
      value: '#333'
    },
    {
      command: 'backColor',
      value: '#666'
    },
    {
      command: 'backColor',
      value: '#999'
    },
    {
      command: 'backColor',
      value: '#bbb'
    },
    {
      command: 'backColor',
      value: '#ddd'
    },
    {
      command: 'backColor',
      value: '#fff'
    },

    {
      command: 'backColor',
      value: '#010'
    },
    {
      command: 'backColor',
      value: '#030'
    },
    {
      command: 'backColor',
      value: '#060'
    },
    {
      command: 'backColor',
      value: '#090'
    },
    {
      command: 'backColor',
      value: '#0b0'
    },
    {
      command: 'backColor',
      value: '#0d0'
    },
    {
      command: 'backColor',
      value: '#0f0'
    },
    {
      command: 'backColor',
      value: '#001'
    },
    {
      command: 'backColor',
      value: '#003'
    },
    {
      command: 'backColor',
      value: '#006'
    },
    {
      command: 'backColor',
      value: '#009'
    },
    {
      command: 'backColor',
      value: '#00b'
    },
    {
      command: 'backColor',
      value: '#00d'
    },
    {
      command: 'backColor',
      value: '#00f'
    },
    {
      command: 'backColor',
      value: '#100'
    },
    {
      command: 'backColor',
      value: '#300'
    },
    {
      command: 'backColor',
      value: '#600'
    },
    {
      command: 'backColor',
      value: '#900'
    },
    {
      command: 'backColor',
      value: '#b00'
    },
    {
      command: 'backColor',
      value: '#d00'
    },
    {
      command: 'backColor',
      value: '#f00'
    },
    {
      command: 'backColor',
      value: '#310'
    },
    {
      command: 'backColor',
      value: '#731'
    },
    {
      command: 'backColor',
      value: '#934'
    },
    {
      command: 'backColor',
      value: '#949'
    },
    {
      command: 'backColor',
      value: '#b32'
    },
    {
      command: 'backColor',
      value: '#d5d'
    },
    {
      command: 'backColor',
      value: '#f4a'
    },
  ],
  fore: [
    {
      command: 'foreColor',
      value: '#000'
    },
    {
      command: 'foreColor',
      value: '#333'
    },
    {
      command: 'foreColor',
      value: '#666'
    },
    {
      command: 'foreColor',
      value: '#999'
    },
    {
      command: 'foreColor',
      value: '#bbb'
    },
    {
      command: 'foreColor',
      value: '#ddd'
    },
    {
      command: 'foreColor',
      value: '#fff'
    },

    {
      command: 'foreColor',
      value: '#010'
    },
    {
      command: 'foreColor',
      value: '#030'
    },
    {
      command: 'foreColor',
      value: '#060'
    },
    {
      command: 'foreColor',
      value: '#090'
    },
    {
      command: 'foreColor',
      value: '#0b0'
    },
    {
      command: 'foreColor',
      value: '#0d0'
    },
    {
      command: 'foreColor',
      value: '#0f0'
    },
    {
      command: 'foreColor',
      value: '#001'
    },
    {
      command: 'foreColor',
      value: '#003'
    },
    {
      command: 'foreColor',
      value: '#006'
    },
    {
      command: 'foreColor',
      value: '#009'
    },
    {
      command: 'foreColor',
      value: '#00b'
    },
    {
      command: 'foreColor',
      value: '#00d'
    },
    {
      command: 'foreColor',
      value: '#00f'
    },
    {
      command: 'foreColor',
      value: '#100'
    },
    {
      command: 'foreColor',
      value: '#300'
    },
    {
      command: 'foreColor',
      value: '#600'
    },
    {
      command: 'foreColor',
      value: '#900'
    },
    {
      command: 'foreColor',
      value: '#b00'
    },
    {
      command: 'foreColor',
      value: '#d00'
    },
    {
      command: 'foreColor',
      value: '#f00'
    },
    {
      command: 'foreColor',
      value: '#310'
    },
    {
      command: 'backColor',
      value: '#731'
    },
    {
      command: 'backColor',
      value: '#934'
    },
    {
      command: 'backColor',
      value: '#949'
    },
    {
      command: 'backColor',
      value: '#b32'
    },
    {
      command: 'backColor',
      value: '#d5d'
    },
    {
      command: 'backColor',
      value: '#f4a'
    },
  ]
}
